import { FirstSaleTrackerPage } from './index'
import { RouteFactory } from './../../shared/router/Route.factory'
import { RequiresAuthGuard } from './../../shared/router/guards'

export default [
  RouteFactory.create(FirstSaleTrackerPage, '/first-sale-tracker', [new RequiresAuthGuard(true)], {
    name: 'First Sale Tracker',
  }),
]
